import { REVIEW_STAR_SVG } from './constants';

export function setViewportProperty(doc) {
  let prevWindowHeight;
  function handleResize() {
    const windowHeight = window.innerHeight;
    if (windowHeight === prevWindowHeight) return;
    requestAnimationFrame(function updateViewportHeight() {
      doc.style.setProperty('--vh', windowHeight * 0.01 + 'px');
      prevWindowHeight = windowHeight;
    });
  }
  handleResize();
  return handleResize;
}

export function generateStarRating(rating) {
  let stars = '';

  for (let i = 1; i <= rating; i++) {
    stars += REVIEW_STAR_SVG.trim();
  }

  return stars;
}
